import React from "react";
import { useSelector } from "react-redux";
import SideBar from "../../components/b2b/SideBar";
import Header from "../../components/landingPage/Header";
// import StatsChart from "./StatsChart";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";

const searchedDestination = [
  {
    name: "Apr 2022",
    Searched: 4000,
    Booked: 2400,
    amt: 2400,
  },
  {
    name: "May 2022",
    Searched: 3000,
    Booked: 1398,
    amt: 2210,
  },
  {
    name: "June 2022",
    Searched: 6600,
    Booked: 5800,
    amt: 2290,
  },
  {
    name: "July 2022",
    Searched: 3780,
    Booked: 2908,
    amt: 2000,
  },
  {
    name: "Aug 2022",
    Searched: 5890,
    Booked: 4800,
    amt: 2181,
  },
  {
    name: "Sept 2022",
    Searched: 2390,
    Booked: 1600,
    amt: 2500,
  },
  {
    name: "Oct 2022",
    Searched: 3490,
    Booked: 1300,
    amt: 2100,
  },
  {
    name: "Nov 2022",
    Searched: 3490,
    Booked: 2000,
    amt: 2100,
  },
  {
    name: "Dec 2022",
    Searched: 3490,
    Booked: 2100,
    amt: 2100,
  },
  {
    name: "Jan 2022",
    Searched: 2090,
    Booked: 1100,
    amt: 2100,
  },
];

const topClientAffiliate = [
  {
    clientname: "Seera",
    affiliatename:"A1 Travel",
    Booked: 9800,
    amt: 2400,
  },
  {
    clientname: "THT Travel",
    affiliatename: "ABC",
    Booked: 6398,
    amt: 2210,
  },
  {
    clientname: "Hills Travel",
    affiliatename: "One World",
    Booked: 5600,
    amt: 2290,
  },
  {
    clientname: "ABC Tours",
    affiliatename: "XYZ",
    Booked: 3908,
    amt: 2000,
  },
  {
    clientname: "Tracklimo",
    affiliatename: "123 Travel",
    Booked: 2600,
    amt: 2181,
  },
];

function Statistics() {
  const { token } = useSelector((state) => state.auth);
  return (
    <div className="h-screen w-screen fixed">
      <Header token={token} />
      <div className="flex">
        <SideBar />
        <div className="h-screen overflow-y-auto scroll">
          <div className="w-full">
            <h2 className="text-left pl-10 my-5 text-slate-600 font-semibold font-body">TOP 10 <span className="text-green-700 font-body">BOOKED DESTINATIONS</span> COMPARED TO <span className="text-red-400 font-body">SEARCHED DESTINATIONS</span></h2>
            <BarChart
            className="text-sm text-slate-700"
              width={1000}
              height={300}
              data={searchedDestination}
              margin={{
                top: 5,
                right: 10,
                left: 20,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="Searched" fill="#f87171" />
              <Bar dataKey="Booked" fill="#00b242" className="text-xs" />
            </BarChart>
          </div>

          <div className="flex my-20">
            <div>
              <h2 className="text-left pl-10 my-5 text-slate-600 font-semibold font-body">TOP 5 <span className="text-red-400 font-body">CLIENTS</span></h2>
              <BarChart
              className="text-sm text-slate-700"
                width={470}
                height={250}
                data={topClientAffiliate}
                margin={{
                  top: 5,
                  right: 10,
                  left: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="clientname" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="Booked" fill="#fb4156" />
                {/* <Bar dataKey="Booked" fill="#939b62" className="text-xs" /> */}
              </BarChart>
            </div>

            <div>
              <h2 className="text-left pl-10 my-5 text-slate-600 font-semibold font-body">TOP 5 <span className="text-red-400 font-body">AFFILIATE</span></h2>
              <BarChart
              className="text-sm text-slate-700"
                width={470}
                height={250}
                data={topClientAffiliate}
                margin={{
                  top: 5,
                  right: 10,
                  left: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="affiliatename" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="Booked" fill="#2493d2" />
                {/* <Bar dataKey="Booked" fill="#939b62" className="text-xs" /> */}
              </BarChart>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Statistics;
